import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import tokenManager from '@/services/tokenManager'

const state = {
  token: tokenManager.token,
  loading: false,
  error: false
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/index.js